import { mapState, mapActions, mapMutations, mapGetters } from 'vuex';
import actions from './actions';
import state from './state';
import getters from './getters';
import mutations from './mutations';

export const serviceComputed = {
	...mapGetters('freeFormStore', Object.keys(getters)),
	...mapState('freeFormStore', Object.keys(state))
};
export const serviceMethods = {
	...mapActions('freeFormStore', Object.keys(actions)),
	...mapMutations('freeFormStore', Object.keys(mutations))
};
